<template>
    <div class="animated fadeIn arpaymfrm">        
        <b-card>
            <div slot="header">
                Adjustment Settlement - Form
                <div class="card-header-actions">
                  <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> {{$t('close')}}</button>
                </div>
            </div>
            <b-row>
            <b-col lg="8">
                <b-row>
                    <b-col lg="6">
                        <b-input-group >
                            <b-input-group-prepend><label>Adjustment Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.paymno" v-b-tooltip.hover title="Jika dikosongkan akan dibuatkan otomatis"></b-form-input>
                        </b-input-group>
                    </b-col>   
                    <b-col lg="5">                            
                        <b-input-group >
                            <b-input-group-prepend><label>Adjustment Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tglpaym" type="date" :state="!$v.model.tglpaym.$error"></b-form-input>                                        
                        </b-input-group>
                    </b-col>
                </b-row>                      
                <b-row>
                    <b-col lg="8">
                    <b-input-group>
                        <b-input-group-prepend><label>Debitur</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.custinfo" :state="!$v.model.customer_id.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuCustomerShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    </b-col>
                    <b-col lg="4">      
                    <b-input-group >
                        <b-input-group-prepend><label style="width:70px;">Kolektor</label></b-input-group-prepend>
                        <b-form-select v-model="model.collector_id" :plain="true" :options="collectors" ></b-form-select>
                    </b-input-group>
                    </b-col>
                </b-row>                      
                <b-input-group >
                    <b-input-group-prepend>
                        <label>Keterangan/Catatan</label>
                        </b-input-group-prepend>
                    <b-form-textarea :rows="2" :max-rows="5" v-model="model.uraian" :state="!$v.model.uraian.$error" ></b-form-textarea>
                </b-input-group>
            </b-col>
            <b-col lg="4">
                <b-input-group >
                    <b-input-group-prepend><label style="width:180px !important;">Total Nett adjustment </label></b-input-group-prepend>
                    <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span></b-input-group-prepend>
                    <my-number class="form-control text-right" separator="," v-model="model.totalbyr" :precision="2" :state="!$v.model.totalbyr.$error"></my-number>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label style="width:180px !important;">Refference Doc. </label></b-input-group-prepend>
                    <b-form-input v-model="model.reff" placeholder="Berita Acara/Memo "></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label style="width:180px !important;">Approval by</label></b-input-group-prepend>
                    <b-form-input v-model="model.approval" placeholder="Approval Berita Acara/Memo"></b-form-input>
                </b-input-group>
            </b-col>
            </b-row>   
            <label><strong>Detail Settlement</strong></label>
            <b-card no-body class="mt-0">
                <b-table
                    class="mb-0"
                    ref="tblArpaymdt"
                    outlined
                    striped hover small 
                    style="font-size:smaller;"
                    :items="arpaymdt.items"
                    :fields="arpaymdt.fields"
                    :current-page="arpaymdt.page"
                    :per-page="arpaymdt.limit"
                    show-empty
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(nilaisettl)="data">
                        {{data.item.nilaisettl|numFormat}}
                        </template>
                        <template v-slot:cell(kurssettle)="data">
                        {{data.item.kurssettle|numFormat('0.000')}}
                        </template>
                        <template v-slot:cell(nilaibank)="data">
                        {{data.item.nilaibank|numFormat}}
                        </template>
                        <template v-slot:cell(nilaidiskon)="data">
                        {{data.item.nilaidiskon|numFormat}}
                        <div v-if="(data.item.Potongan)">{{data.item.Potongan}}</div>
                        </template>
                        <template v-slot:cell(selisihkurs)="data">
                        {{data.item.selisihkurs|numFormat('0,0.00')}}
                        </template>

                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editArpaymdt(data.item,data.toggleDetails)">
                                <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delArpaymdt(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                    <template v-slot:row-details="row">
                        <b-card no-body class="row-details-form">
                            <b-row align-h="around" class="p-1">
                                <b-col lg="6">
                                    <b-input-group >
                                        <b-input-group-prepend><label>Nama Debitur</label></b-input-group-prepend>
                                        <b-form-input v-model="arpaymdtObj.CustName" disabled style="width:35% !important;"></b-form-input>
                                        <b-input-group-prepend><span class="input-group-text">No. Pinjaman</span></b-input-group-prepend>
                                        <b-form-input readonly v-model="arpaymdtObj.no_kontrak" @keyup.13.native="lkuPinjamanoutstandShow=true" :state="!$v.arpaymdtObj.pinjamankey.$error"></b-form-input>
                                        <b-input-group-append>
                                        <b-btn text="Button" @click="lkuPinjamanoutstandShow=true" >
                                            <i class="fa fa-search"></i>
                                        </b-btn>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <b-input-group >
                                        <b-input-group-prepend><label>Penggunaan Pinjaman</label></b-input-group-prepend>
                                        <b-form-input v-model="arpaymdtObj.uraian" disabled></b-form-input>
                                    </b-input-group>
                                    <b-row no-gutters>
                                        <b-col lg="6">
                                            <b-input-group >
                                                <b-input-group-prepend><label>Outstanding Pokok</label></b-input-group-prepend>
                                                <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{arpaymdtObj.matauang}}</span></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="arpaymdtObj.outstand_pokok" :precision="2" disabled></my-number>
                                            </b-input-group>
                                        </b-col>
                                        <b-col lg="6">
                                            <b-input-group >
                                                <b-input-group-prepend><label>Outstanding Denda</label></b-input-group-prepend>
                                                <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{arpaymdtObj.matauang}}</span></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="arpaymdtObj.outstand_denda" :precision="2" disabled></my-number>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>
                                    <b-row no-gutters>
                                        <b-col lg="6">
                                            <b-input-group >
                                                <b-input-group-prepend><label>Outstanding Bunga</label></b-input-group-prepend>
                                                <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{arpaymdtObj.matauang}}</span></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="arpaymdtObj.outstand_bunga" :precision="2" disabled></my-number>
                                            </b-input-group>
                                        </b-col>
                                        <b-col lg="6">
                                            <b-input-group >
                                                <b-input-group-prepend><label>TOTAL Outstanding</label></b-input-group-prepend>
                                                <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{arpaymdtObj.matauang}}</span></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="arpaymdtObj.outstand" :precision="2" readonly></my-number>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>
                                    <!-- <b-row no-gutters>
                                        <b-col lg="7">
                                            <b-input-group >
                                                <b-input-group-prepend><label>Not Posted Settl.Amt</label></b-input-group-prepend>
                                                <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{arpaymdtObj.matauang}}</span></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="arpaymdtObj.byr_semu" :precision="2" disabled></my-number>
                                            </b-input-group>
                                        </b-col>
                                        <b-col lg="5">
                                            <b-input-group >
                                                <b-input-group-prepend class="d-md-inline d-lg-none"><label>Not Posted Settl.Doc</label></b-input-group-prepend>
                                                <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Not Posted Settl.Doc</span></b-input-group-prepend>
                                                <b-form-input v-model="arpaymdtObj.byr_semu_doc" disabled></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                    </b-row> -->
                                </b-col>
                                <b-col lg="6">        
                                    <b-row no-gutters>
                                        <b-col lg="5">
                                            <b-input-group >
                                                <b-input-group-prepend><label>Jenis Settle</label></b-input-group-prepend>
                                                <b-form-select v-model="arpaymdtObj.nilaisettl_desc" :plain="true" :options="['POKOK','BUNGA','DENDA']" :state="!$v.arpaymdtObj.nilaisettl_desc.$error"></b-form-select>
                                            </b-input-group>
                                        </b-col>
                                        <b-col lg="7">
                                            <b-input-group >
                                                <b-input-group-prepend><label>Nilai Settlement</label></b-input-group-prepend>
                                                <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{arpaymdtObj.matauang}}</span></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="arpaymdtObj.nilaisettl" :state="!$v.arpaymdtObj.nilaisettl.$error" @change="updateNilaibank"
                                                :precision="2"  :disabled="((model.model_pinjaman=='PAB') && (arpaymdtObj.nilaisettl_desc!='DENDA'))"></my-number>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>
                                    <b-row no-gutters>
                                        <b-col lg="5">
                                            <b-input-group >
                                                <b-input-group-prepend><label>Settle dg Diskon</label></b-input-group-prepend>
                                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="arpaymdtObj.nilaidiskon" :precision="2" ></my-number>
                                            </b-input-group>
                                        </b-col>
                                        <b-col lg="7">
                                            <b-input-group >
                                                <b-input-group-prepend><label>Settle dg Kas/Bank</label></b-input-group-prepend>
                                                <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="arpaymdtObj.nilaibank" :precision="2" :state="!$v.arpaymdtObj.nilaibank.$error"></my-number>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>
                                        <b-row no-gutters>
                                        <b-col lg="5">
                                        </b-col>
                                            <b-col lg="7">
                                                <b-input-group v-if="(model.matauang != arpaymdtObj.matauang)">
                                                    <b-input-group-prepend><label>Kurs {{model.matauang}} </label></b-input-group-prepend>
                                                    <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{arpaymdtObj.matauang}}</span></b-input-group-prepend>
                                                    <my-number class="form-control text-right" v-model="arpaymdtObj.kurssettle" :precision="6" :state="!$v.arpaymdtObj.kurssettle.$error"></my-number>
                                                </b-input-group>
                                            </b-col>
                                        </b-row>
                                    <b-input-group >
                                        <b-input-group-prepend><label>Cash Flow Account</label></b-input-group-prepend>
                                        <b-form-input readonly v-model="arpaymdtObj.cashflow" @keyup.13.native="showLkuCashflow('arpaymdt')" :state="!$v.arpaymdtObj.kodecash.$error"></b-form-input>
                                        <b-input-group-append>
                                        <b-btn text="Button" @click="showLkuCashflow('arpaymdt')">
                                            <i class="fa fa-search"></i>
                                        </b-btn>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
                            </b-row>                            

                            <b-row class="justify-content-center mb-2">
                                <b-button v-if="saveEnabled" class="btn btn-success mr-1" @click="saveArpaymdt()">Update</b-button>
                                <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                            </b-row>
                        </b-card>
                    </template>   
                    <template v-slot:empty="scope">
                        <h6 class="text-center">Tidak ada data detail settlement.
                            <!-- {{ scope.emptyText }} -->
                            </h6>
                    </template>
                    <template v-slot:emptyfiltered="scope">
                        <h6>{{ scope.emptyFilteredText }}</h6>
                    </template>                     
                </b-table>
                <b-row class="mt-2">
                    <b-col lg="9">
                        <b-row >
                        <b-col cols="2">            
                            <!-- <b-button size="sm" class="ml-1" @click="addArpaymdt" :disabled="!(model.customer_id)">Add Settlement</b-button>                           -->
                            <b-button size="sm" class="ml-1" @click="addArpaymdt" >Add Settlement</b-button>                          
                        </b-col>
                        <b-col cols="10">
                            <div style="display: flex;margin:0;padding:0;">
                                <div style="margin:0;padding:5px;width:500px; text-align:right;">
                                    Showing {{(arpaymdt.page - 1) * arpaymdt.limit + 1}}
                                    to <span v-if="((arpaymdt.page * arpaymdt.limit)>arpaymdt.total)">{{arpaymdt.total}}</span> <span v-else>{{arpaymdt.page * arpaymdt.limit}}</span>
                                    of {{arpaymdt.total}} ,   <span class="mr-1"> per page :</span> 
                                    <select  v-model="arpaymdt.limit"  style="width:60px;">
                                    <option>5</option>
                                    <option>10</option>
                                    <option>15</option>
                                    <option>20</option>                            
                                    <option>25</option>
                                    <option>30</option>                            
                                    <option>40</option>                            
                                    <option>50</option>                            
                                    <option>60</option>                            
                                    <option>70</option>                            
                                    <option>80</option>                            
                                    <option>90</option>                            
                                    </select>
                                </div>
                                <div>
                                    <b-pagination  class="ml-1" 
                                    align="left"
                                    :total-rows="arpaymdt.total"
                                    :per-page="arpaymdt.limit"
                                    v-model="arpaymdt.page"
                                    ></b-pagination>
                                </div>
                            </div>
                        </b-col>
                        </b-row>
                    </b-col>
                    <b-col lg="3">
                            <b-input-group >
                                <b-input-group-prepend><label style="width:170px !importnat;" >Total Detail Settlement</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="totalDtlPaym" :precision="2" disabled></my-number>
                            </b-input-group>
                    </b-col>
                </b-row>

            </b-card>    
            <b-row align-h="between">
                <b-col lg="4">
                            <div class="text-right">
                                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                                <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> {{$t('close')}}</button>
                            </div>
                </b-col>
            </b-row>
        </b-card>
        <b-modal v-model="lkuPinjamanoutstandShow" size="lg" :hide-footer="true" title="Daftar Pinjaman Outstanding"  :key="model.customer_id" :centered="true">
            <lku-pinjamanoutstand @click="onSelectLkuPinjamanoutstand" :customer="model.custinfo" :customer_id="model.customer_id" :formdata="lkuPinjamanoutstandData"></lku-pinjamanoutstand>
        </b-modal>        
        <b-modal v-model="lkuCashflowShow" size="lg" :hide-footer="true" title="List of Cashflow Account" :centered="true">
            <lku-cashflow @click="onSelectLkuCashflow"></lku-cashflow>
        </b-modal>        
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="Daftar Debitur" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        
        <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
            <lku-bankaccount @click="onSelectLkuBankaccount" :isbank="bankOnly" :key="bankOnly"></lku-bankaccount>
        </b-modal>        
    </div>
</template>
<style lang="scss">
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 120px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
// import vDim from "../lookup/dim";
import lkuPinjamanoutstand from "./lkuPinjamanoutstand";
import lkuBankaccount from "../lookup/lkuBankaccount";
import lkuCashflow from "../lookup/lkuCashflow";
import lkuCustomer from "./lkuDebitur";
import arpayment from '../../apis/pinjamanpayment';
import crud from "../../apis/crud";
// import dimension from "../../apis/dim";
import { validationMixin } from "vuelidate";
import { required, requiredIf, requiredUnless, minValue, minLength, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber, lkuPinjamanoutstand,lkuBankaccount,lkuCashflow,lkuCustomer},
  mixins: [validationMixin],
  validations: {
        model: {
            // paymno: { required },
            uraian: { required },
            tglpaym: { required },
            jenis: { required },
            tgl_terima: { required:(function() {
                if ((this.model.jenis !=='Cheque') && (this.model.jenis !=='Giro')) {
                    return true;
                } else if (this.model.tgl_terima){
                    return true;
                } else return false;
            }) },
            // artype: { required:(function() {
            //     if (this.model.settl_amt==this.model.totalbyr) {
            //         return true;
            //     } else if (this.model.artype){
            //         return true;
            //     } else return false;
            // }) },
            matauang: { required },
            customer_id: { required },
            totalbyr: { required, minValue:minValue(0.01) },
            totalbank: { required, minValue:minValue(0.01) },
            totaldiskon: { required, minValue:minValue(0) },
            kurstrx: { required, minValue:minValue(0.00000001) }
        },
        arpaymdtObj :{
            pinjamankey: { required },
            nilaisettl_desc: { required },
            nilaisettl: { minValue:(function() {
                if (this.adaPotongan) {
                    return true;
                } else if ((this.arpaymdtObj.nilaisettl || 0 )<0.01){
                    return false;
                } else return true;
            }) },
            nilaibank: { minValue:(function() {
                if (this.adaPotongan) {
                    return true;
                } else if ((this.arpaymdtObj.nilaibank || 0 )<0){
                    return false;
                } else return true;
            }) },
            nilaidiskon : { required:(function() {
                if ((this.arpaymdtObj.nilaibank || 0 )> 0.01 ) {
                    return true;
                } else if ((this.arpaymdtObj.nilaidiskon || 0 ) <0){
                    return false;
                } else return true;                
            }) },
            kurssettle: { required, minValue:minValue(0.0000001) },  
            kodecash : { required:(function() {
                if ((this.arpaymdtObj.nilaibank || 0) == 0) {
                    return true;
                } else if ((this.arpaymdtObj.kodecash || '')==''){
                    return false;
                } else return true;
            }) },
        },
  }, 
  data() {
    return {
        arGroups : [],collectors:[],
        currency:[{value:'IDR',text:'IDR'}],
        potongans:[],
        saveEnabled:true,
        horizontal:true,
        jenisPaym : ['Cheque', 'Giro', 'Transfer', 'Tunai'],
        model:{jenis:'Giro',kodecash:'',kodebank:'',kurstrx:1,
            tglpaym:moment().format('YYYY-MM-DD'), totalbank:0, totaldiskon:0,
            tgl_terima:'', matauang:'',totalbyr:'', customer_id:'', settl_amt:0
            },
        lblExchRate:"Exch. Rate ",
        bankOnly:1,
        lkuBankaccountShow:false,
        lkuCashflowShow: false,
        lkuCashflowCaller:'arpaymdt',        
        totalDtlPaym:0,
        updateDimHdr:false,
        updateDimDtl:true,
        arpaymdt: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "no_kontrak",
                    label: "No. Kontrak",
                    thStyle: "width:140px",
                    sortable: true
                },
                {
                    key: "uraian",
                    label: "Uraian Pinjaman",
                    sortable: true
                },
                {
                    key: "angsuran_ke",
                    label: "Angsuran ke-",
                    thStyle: "width:60px",
                    sortable: true
                },
                {
                    key: "tgl_jttempo",
                    thStyle: "width:90px",
                    label: "Tgl. Jt.Tempo",
                    thClass: "text-center",
                    tdClass: "text-center",
                    sortable: true
                },
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "$,¥",
                    sortable: true
                },
                {
                    key: "nilaisettl_desc",
                    label: "Jenis Settlement",
                    thStyle: "width:100px",
                    thClass: "text-center",
                    tdClass: "text-center",
                    sortable: true
                },
                {
                    key: "nilaisettl",
                    label: "Nilai Settlement",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right",
                    sortable: true
                },
                {
                    key: "nilaibank",
                    label: "Nilai Cash/Bank",
                    thStyle: "width:142px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaidiskon",
                    label: "Nilai Diskon",
                    thStyle: "width:120px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:40px",
                    thClass: "text-center",
                },

            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        arpaymdtObj:{pinjamankey:'', kodecash:'',nilaisettl_desc:'POKOK', nilaidiskon:'', nilaibank:'', nilaisettl:''},
        lkuPinjamanoutstandShow: false,
        lkuPinjamanoutstandData:{},
        lkuCustomerShow:false,
        tabIndex:0
    };
},
  computed: {
    uanguser(){
      return this.$store.state.user.matauang;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidArpaymdt() {
      this.$v.arpaymdtObj.$touch();
      return this.$v.arpaymdtObj.$invalid;
    },
    // dimension(){
    //   return this.$store.state.dimension;
    // },
    caraBayar(){
        return this.model.jenis;
    },
    bankkas(){
        return this.model.kodebank;
    },
    adaPotongan(){
        return ((this.arpaymdtObj.nilaidiskon || 0) != 0);
    },
    nilaisettl_desc(){return this.arpaymdtObj.nilaisettl_desc;},
    adaNilaiBank(){return ((this.arpaymdtObj.nilaibank || 0) != 0);},
  },
  watch: {
    "arpaymdtObj.nilaisettl_desc": function(newVal){
        switch (newVal) {
            case 'BUNGA':
                this.arpaymdtObj.nilaisettl= this.arpaymdtObj.outstand_bunga;
                this.arpaymdtObj.nilaibank= this.arpaymdtObj.outstand_bunga;
                break;
        
            case 'DENDA':
                this.arpaymdtObj.nilaisettl= this.arpaymdtObj.outstand_denda;
                this.arpaymdtObj.nilaibank= this.arpaymdtObj.outstand_denda;
                break;
        
            default:
                this.arpaymdtObj.nilaisettl= this.arpaymdtObj.outstand_pokok;
                this.arpaymdtObj.nilaibank= this.arpaymdtObj.outstand_pokok;
                break;
        }
    },
    "model.totalbyr": function(newVal){
        this.model.totaldiskon=newVal-this.model.totalbank;
    },
    "model.totalbank": function(newVal){
        this.model.totaldiskon=this.model.totalbyr-newVal;
    },
    caraBayar: function(jenis) {
        if (jenis==='Tunai') {
            this.bankOnly='0';
        } else {
            this.bankOnly='1';
        }
        // if (this.model.isbank!=this.bankOnly) {
        //     this.model.kodebank='';
        //     this.model.namabank='';
        // }
        if (!this.bankOnly) {
            this.model.kodebank='';
            this.model.namabank='';
        }
    },    
    bankkas: function(kode) {
            if (this.uanguser.trim() == this.model.matauang.trim()) {
                this.model.kurstrx = 1;
            }
    },    
    nilaisettl_desc: function(kode) {
        let pot = this.potongans.find(r => r.value===kode);
        if (pot){
            this.arpaymdtObj.Potongan=pot.text;
        }
    },    
  },
  created: async function(){
      this.model.matauang=this.uanguser;
      if (this.$route.params.arpaymKey) {
          toastr.info('Loading Adjustment Detail, please wait')
          try {

            // const data = await arpayment.arpaymdetail(this.$route.params);  
            const [a,c,d,e,data] = await Promise.all([arpayment.currency(),await arpayment.argroup(),await arpayment.potongan(),
                                    crud.list({tablename: "vwcollector",page: 1,limit: 1000,sortBy: "collector_name",sortDesc: false}),
                                    arpayment.arpaymdetail(this.$route.params)]) ;
            this.currency = a;
            this.arGroups = c;
            this.potongans = d;
            this.collectors = e.reduce((newArr,item) =>{
                newArr.push({ value: item.collector_id, text: item.collector_name});
                return newArr;
            },[]);          
            const row = data[0];
            this.saveEnabled=(row.statusar === 0);
            row.tglpaym = row.tglpaym ? moment(row.tglpaym).format('YYYY-MM-DD') : '';
            row.tgl_giro = row.tgl_giro ? moment(row.tgl_giro).format('YYYY-MM-DD') : '';
            row.tgl_terima = row.tgl_terima ? moment(row.tgl_terima).format('YYYY-MM-DD') : '';
            
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.arpaymdt.items = data[1];
            this.calcTotalDtlPaym();
            // this.updateDimHdr = !this.updateDimHdr;
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
        // const [a,c,d,e] = await Promise.all([arpayment.currency(),await arpayment.argroup(),await arpayment.potongan(),
        //                 crud.list({tablename: "vwcollector",page: 1,limit: 1000,sortBy: "collector_name",sortDesc: false})]) ;
        // this.currency = a;
        // this.arGroups = c;
        // this.potongans = d;
        //     this.collectors = e.reduce((newArr,item) =>{
        //         newArr.push({ value: item.collector_id, text: item.collector_name});
        //         return newArr;
        //     },[]);            

      }
  },
  methods: {
    showLkuCashflow(callerObj) {
        this.lkuCashflowShow=true;
        this.lkuCashflowCaller=callerObj;
    },
    onSelectLkuCashflow(_selected) {
        this.arpaymdtObj.cashflow = _selected.kodecash.trim() + ' | ' + _selected.namacash.trim();
        this.arpaymdtObj.kodecash = _selected.kodecash;
        this.arpaymdtObj.namacash = _selected.namacash;
        this.lkuCashflowShow=false;
    },
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;            
        const opened= this.arpaymdt.items.find( r=> r._showDetails==true);
        if (opened) {
            toastr.warn('Detail Form Un Saved');
            return;
        }
        let settl_amt=0;
        let newArpaymdts = this.arpaymdt.items.reduce((newArr, item) => {
            if ((item.pinjamankey || '') != '') {
                // item.kurspost = this.model.kurstrx;
                settl_amt += item.nilaibank + item.nilaidiskon;
                newArr.push(item);
            }
            return newArr;
        }, []);
        this.model.settl_amt=settl_amt;

        if (this.invalidModel) {
            console.log('validation model : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else if (this.totalDtlPaym > parseFloat(this.model.totalbyr)) {
            toastr.error('[Total Settle. pembayaran] not Balance with [Total Detail Adjustment]', "ERROR MESSAGE");
        } else if (this.totalDtlBank > parseFloat(this.model.totalbank)) {
            toastr.error('[Jumlah Penerimaan Kas/Bank] not Balance with [Total Detail Bank]', "ERROR MESSAGE");
        } else if (this.totalDtlDiskon > parseFloat(this.model.totaldiskon)) {
            toastr.error('[Jumlah Potongan/Diskon] not Balance with [Total Detail Diskon]', "ERROR MESSAGE");
        } else {
            if (parseFloat(this.model.totalbyr)>this.totalDtlPaym) {
                toastr.warn('[Total Adjustment Header] is greter than [Total Adjustment Detail]');
            }            
            try {

                    this.model.paymno = this.model.paymno || '';
                    this.model.statusar = this.model.statusar || 0;
                    this.model.statustre = this.model.statustre || 0;
                    this.model.totalbyr = this.model.totalbyr || 0;
                    this.model.totalbank = this.model.totalbank || 0;
                    this.model.totaldiskon = this.model.totaldiskon || 0;
                    this.model.bcharge = this.model.bcharge || 0;

                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.tglpaym = moment(row.tglpaym).format('YYYY-MM-DD');
                    row.tgl_giro = row.tgl_giro ? moment(row.tgl_giro).format('YYYY-MM-DD') : undefined;
                    row.tgl_terima = row.tgl_terima ? moment(row.tgl_terima).format('YYYY-MM-DD') : moment(row.tglpaym).format('YYYY-MM-DD');
                    row.settl_amt=settl_amt;

                    row.arpaymdt = newArpaymdts;
                    await arpayment.insert(row);
                    toastr.success("Complete successfully", "Save Receipt");
                    this.close();

            } catch (error) {
                this.saveEnabled=true;            
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "Save Receipt Error");                
            }

        }
    },
    closeArPayment: function(){
        const opened= this.arpaymdt.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addArpaymdt : function () {
        let goAhead=true;
        if (this.model.totalbyr) {
            if ((this.model.totalbyr - this.totalDtlPaym)<0) {
                goAhead=false;
            }
        }

        if (goAhead==true) {
            this.closeArPayment();
            const obj={_showDetails:true};
            this.arpaymdt.selected = obj;
            for (var key in this.arpaymdtObj) {
                this.arpaymdtObj[key] = '';
            }
            this.arpaymdtObj.kurssettle=1;
            this.tabIndex = 0;
            this.arpaymdt.items.push(obj);
            this.arpaymdt.total=this.arpaymdt.items.length;
        } else {
            toastr.error('UnSettled Amount can not be less then zero');
        }
    },
    editArpaymdt : function (obj,callback) {
        this.closeArPayment();
        this.arpaymdt.selected = obj;
        for (var key in this.arpaymdtObj) {
            this.arpaymdtObj[key] = '';
        }
        for (var key in obj) {
            this.arpaymdtObj[key] = obj[key];
        }
        setTimeout(() => {
            this.tabIndex = (this.adaNilaiBank) ? 0:1;            
        }, 200);
        callback();
    },
    delArpaymdt: function (index) {
        if (index > -1) {
        this.arpaymdt.items.splice(index, 1);
        }
        this.arpaymdt.total=this.arpaymdt.items.length;
        this.calcTotalDtlPaym();
    },
    updateNilaibank: function() {
        if (this.model.matauang==this.arpaymdtObj.matauang)
        {
            this.arpaymdtObj.nilaibank=this.arpaymdtObj.nilaisettl - (this.arpaymdtObj.nilaidiskon || 0) ;
        }
    },    
    saveArpaymdt: function (callback) {
        this.arpaymdtObj.nilaisettl = this.arpaymdtObj.nilaisettl || 0;
        this.arpaymdtObj.nilaidiskon = this.arpaymdtObj.nilaidiskon || 0;
        switch ( this.arpaymdtObj.nilaisettl_desc) {
            case 'BUNGA':
                this.arpaymdtObj.nilaisettl_pokok= 0;
                this.arpaymdtObj.nilaisettl_bunga= this.arpaymdtObj.nilaisettl;
                this.arpaymdtObj.nilaisettl_denda= 0;
                break;
        
            case 'DENDA':
                this.arpaymdtObj.nilaisettl_pokok= 0;
                this.arpaymdtObj.nilaisettl_bunga= 0;
                this.arpaymdtObj.nilaisettl_denda= this.arpaymdtObj.nilaisettl;
                break;
        
            default:
                this.arpaymdtObj.nilaisettl_pokok= this.arpaymdtObj.nilaisettl;
                this.arpaymdtObj.nilaisettl_bunga= 0;
                this.arpaymdtObj.nilaisettl_denda= 0;
                break;
        }
                
      if (this.invalidArpaymdt) {
            console.log('validation : ', this.$v.arpaymdtObj);
            console.log('model obj : ',this.arpaymdtObj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            let totInvSttl = this.arpaymdt.items.reduce((tot, item) => {
                            if (item.pinjamankey == this.arpaymdtObj.pinjamankey) {
                                tot + (item.nilaisettl||0);
                            }
                            return tot;
                        }, this.arpaymdtObj.nilaisettl );
            if (this.arpaymdt.selected.pinjamankey == this.arpaymdtObj.pinjamankey)
                totInvSttl= totInvSttl -  (this.arpaymdt.selected.nilaisettl||0);

            if ((totInvSttl-this.arpaymdtObj.outstand_total) > 0.01) {
                toastr.error('Settled Amount exceeds Outstanding Amount', "ERROR MESSAGE");
            } else {
                this.arpaymdtObj.selisihkurs = (this.arpaymdtObj.nilaibank+this.arpaymdtObj.nilaidiskon) - (this.arpaymdtObj.nilaisettl * this.arpaymdtObj.kurssettle) ;
                for (var key in this.arpaymdtObj) {
                    this.arpaymdt.selected[key] = this.arpaymdtObj[key];
                }
                this.calcTotalDtlPaym();
                this.arpaymdt.selected._showDetails=false;
                if (callback) callback();
            }
       }
    },
    onSelectLkuPinjamanoutstand(invLookup) {
        for (var key in invLookup.selected) {
            this.arpaymdtObj[key] = invLookup.selected[key];
        }        
        this.arpaymdtObj.pinjamankey=invLookup.selected.pinjamankey;
        this.arpaymdtObj.angsurankey=invLookup.selected.angsurankey || '';
        this.arpaymdtObj.tgl_jttempo= invLookup.selected.tgl_jttempo?moment(invLookup.selected.tgl_jttempo).format('YYYY-MM-DD'):'';
        // this.arpaymdtObj.matauang=invLookup.selected.matauang;
        // this.arpaymdtObj.no_kontrak=invLookup.selected.no_kontrak;
        // this.arpaymdtObj.uraian=invLookup.selected.uraian;
        // this.arpaymdtObj.model_pinjaman=invLookup.selected.model_pinjaman;
        // this.arpaymdtObj.outstand_pokok=invLookup.selected.outstand_pokok;
        // this.arpaymdtObj.outstand_bunga=invLookup.selected.outstand_bunga;
        // this.arpaymdtObj.outstand_denda=invLookup.selected.outstand_denda;
        // this.arpaymdtObj.outstand_total=invLookup.selected.outstand_total;

        if (this.arpaymdtObj.matauang.trim() == this.model.matauang.trim()) {
            this.arpaymdtObj.nilaibank=this.arpaymdtObj.nilaisettl;
            this.arpaymdtObj.kurssettle = 1;
            this.arpaymdtObj.selisihkurs = 0;
        }
        this.lkuPinjamanoutstandShow=false;
        this.lkuPinjamanoutstandData=invLookup;
        // arpayment.byrsemu(invLookup.selected).then(result => {
        //         this.arpaymdtObj.byr_semu= result.byr_semu;
        //         this.arpaymdtObj.byr_semu_doc= result.byr_semu_doc;
        //     })
        //     .catch(err => {
        //         console.log('byrsemu -> ', err);
        //     });
    },

    onSelectLkuBankaccount(_selected) {
        this.model.kodebank=_selected.kode;
        this.model.matauang=_selected.matauang;
        this.model.namabank=_selected.namabank;
        this.model.nomorrek=_selected.nomorrek;
        this.model.isbank=_selected.isbank;
        this.lkuBankaccountShow=false;
    },
    onSelectLkuCustomer: async function (_selected) {
        this.model.custinfo = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        this.model.custcode = _selected.CustCode;
        this.model.CustName = _selected.CustName;
        this.model.customer_id = _selected.nasabahkey;
        this.model.collector_id= _selected.collector;
        this.lkuCustomerShow=false;
    },

    // updateDimDtl2Hdr: function (dimDtl) {
    //     var dimHdr = this.model;
    //     this.dimension.forEach((dim) => {
    //         if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
    //             dimHdr[dim.value] = dimDtl[dim.value];
    //             dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
    //             dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
    //         }
    //     });
    //     this.updateDimHdr = !this.updateDimHdr;
    // },
    // updateDimHdr2Dtl: function (dimDtl) {
    //     var dimHdr = this.model;
    //     dimDtl = dimDtl || this.othPayment.obj;
    //     this.dimension.forEach((dim) => {
    //         if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
    //             dimDtl[dim.value] = dimHdr[dim.value];
    //             dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
    //             dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
    //         }
    //     });
    //     this.updateDimDtl = !this.updateDimDtl;
    // },
    calcTotalDtlPaym: function () {
        let totalDtlPaym = this.model.bcharge || 0;
        let totalDtlBank = this.model.bcharge || 0;
        let totalDtlDiskon=0;
        totalDtlPaym = totalDtlPaym || 0;
        this.arpaymdt.items.forEach( function (trx) {
            if (trx.pinjamankey){
                totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaibank)+ parseFloat(trx.nilaidiskon);
                totalDtlDiskon = totalDtlDiskon + parseFloat(trx.nilaidiskon);
                totalDtlBank = totalDtlBank + parseFloat(trx.nilaibank);
            }         
        });
        this.totalDtlPaym = totalDtlPaym;
        this.model.totalbyr = totalDtlPaym;
        this.totalDtlBank = totalDtlBank;
        this.model.totalbank=totalDtlBank;
        this.totalDtlDiskon = totalDtlDiskon;
        this.model.totaldiskon = totalDtlDiskon;
    },
    // close(){
    //   if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name!=='receivable.arpaymfrm'))  {
    //     router.push({name:'receivable.arpaymlist'});
    //   } else {
    //     router.push({name:'receivable.home'});
    //   }
    // }
    close(){
      router.push({name:"loan.paymlist"});
    }
  }
};
</script>
